export const view = {
    methods: {
        updateQuantityInput: function (e) {
            var _self = this;
            var diff = e.target.getAttribute('data-diff');
            var input = e.target.parentNode.querySelector('input');
            var updatedVal = _self.tryParseInt(input.value) + _self.tryParseInt(diff);

            if (updatedVal < 0)
                updatedVal = 0;

            input.value = updatedVal
            input.dispatchEvent(new Event('change'));
        },
        updateQuantity: function (e) {
            var element = e.target;
            var _self = this;
            var container = element.closest('.cart-menuItem');
            var quantity = _self.tryParseInt(element.value);
            var prevQuantity = _self.tryParseInt(element.getAttribute('data-quantity'));

            if (quantity <= 0) {
                removeItem(_self, container);
                return;
            }


            var diff = quantity - prevQuantity;
            element.getAttribute('data-quantity', quantity);
            element.value = quantity;

            var parameters = {
                SKU: element.getAttribute('data-sku'),
                Quantity: diff,
                FranchiseID: localStorage.franchiseID,
                Guid: localStorage.cartGuid
            }
            this.$ooApi.orders.cart.update.v1(parameters).then(function (response) {
                if (response.success)
                    updateTotal(_self);
                else
                    console.log(response.message);
            })
            // check .catch
        },
        checkout: function () {
            var _self = this;
            var parameters = {
                Guid: localStorage.cartGuid,
                FranchiseID: localStorage.franchiseID
            };
            _self.$ooApi.orders.cart.eligible.v1(parameters).then(function (response) {
                if (response.success) {
                    _self.$router.push('Checkout');
                }
                else {
                    console.log(response.message);
                    _self.$router.push({ path: 'Login', query: { ReturnUrl: 'Checkout' } });
                }
            })
            // check .catch
        },
    }
}
function updateTotal(_self) {
    var items = document.querySelectorAll('.cart-menuItem');
    var total = 0.00;
    var taxTotal = 0.00;
    items.forEach(item => {
        var singlePrice = _self.tryParseFloat(item.querySelector('.product-price').getAttribute('data-price'), 0);
        var taxPerc = _self.tryParseFloat(item.querySelector('.product-price').getAttribute('data-tax'), 0) / 100.00;
        var taxPrice = singlePrice * taxPerc;
        var quantity = _self.tryParseFloat(item.querySelector('input#number').value, 0)
        item.querySelector('.product-price').textContent = (singlePrice * quantity).toFixed(2)
        taxTotal += taxPrice * quantity
        total += singlePrice * quantity;
    });
    document.querySelector('.cart-total').textContent = total.toFixed(2);
    document.querySelector('.cart-total-tax').textContent = taxTotal.toFixed(2);
    document.querySelector('.cart-total-excluding-tax').textContent = (total - taxTotal).toFixed(2);
    _self.refreshCart();
}
function removeItem(_self, container) {
    var sku = container.getAttribute('data-sku')

    var parameters = {
        FranchiseID: localStorage.franchiseID,
        Guid: localStorage.cartGuid,
        Sku: sku
    };
    _self.$ooApi.orders.cart.remove.v1(parameters).then(function (response) {
        if (response.success) {
            container.parentNode.removeChild(container);
            updateTotal(_self);
        }
        else
            console.log(response.message);
    })
    // check .catch
}